import React from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

const IconBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  min-width: 48px;
  height: 48px;
  background: ${cssTheme.colors.background.brand.inverse};
  border: 1px solid ${cssTheme.colors.border.neutral.secondary};
  color: ${cssTheme.colors.content.brand.primary};
  border-radius: ${cssTheme.layout.radius.lg};
`

interface IconBadgeProps {
  /** Icon element to display */
  iconElement?: React.ReactNode
  /** Additional CSS class name */
  className?: string
}

export const IconBadge = ({iconElement, className}: IconBadgeProps) => {
  return (
    <IconBadgeWrapper className={className}>{iconElement}</IconBadgeWrapper>
  )
}
